import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Observable, takeUntil } from 'rxjs';
import {
  ComparisonOperator,
  CustomResultOfPaginatedListOfPhonebookDto,
  GetEnumValuesDto,
  PhonebookDto,
} from 'src/app/core/api/models';
import { PhonebooksService } from 'src/app/core/api/services';
import { OnlyNumberDirective } from 'src/app/core/directives/only-number.directive';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { ThemeColorDirective } from 'src/app/core/utils/theme/theme-color.directive';
import { TranslationModule } from 'src/app/i18n';
import { DynamicTableModule } from 'src/app/shared/global/dynamic-table/dynamic-table.module';
import { FormBtnsModule } from 'src/app/shared/global/form-btns/form-btns.module';
import { TdValueModule } from 'src/app/shared/global/td-value/td-value.module';
import { PhonebookListComponent } from '../phonebook-list/phonebook-list.component';
import { PhonebookRowComponent } from '../phonebook-row/phonebook-row.component';
import { PhonebookCustomDto } from '../shared/phonebook-custom.model';
import { FormFieldSearcherModule } from './../../../../shared/components/form-fields/form-field-searcher/form-field-searcher.module';
import { FieldSearcherOutput } from './../../../../shared/global/field-searcher/field-searcher-event.model';
import { BaseIndexModule } from 'src/app/pages/shared/base';

@Component({
  selector: 'phonebook-advance-search',
  imports: [
    FormFieldSearcherModule,
    ReactiveFormsModule,
    FormsModule,
    FormBtnsModule,
    DynamicTableModule,
    TdValueModule,
    ThemeColorDirective,
    PhonebookRowComponent,
    BaseIndexModule,
  ],
  templateUrl: './phonebook-advance-search.component.html',
})
export class PhonebookAdvanceSearchComponent extends PhonebookListComponent {
  currentService = inject(PhonebooksService);
  items$: Observable<Array<PhonebookDto>>;
  items: PhonebookCustomDto[] = [];
  //#region props
  pageName = 'phonebookAdvancedSearch';
  fields = 'pages.phonebook.form.fields.';
  form: FormGroup;
  get ComparisonOperator() {
    return ComparisonOperator;
  }
  PhonebookTypesEnumValues: GetEnumValuesDto[] = [];
  @Input() isShowMenus: boolean = false;
  //#endregion

  ngOnInit(): void {
    this.initForm();
    super.initTablePagination();
    super.setDefaultTableSort();
    this.configTableColumns();
    this.configPage();
    this.getEnumsValues();
    if (!this.isShowFullTable) {
      this.pageConfig.tableConfig.showOperationColumn = false;
    }
    this.pageConfig.tableConfig.isFixedHeight = true;
  }

  configTableColumns() {
    super.configTableColumns();
    this.tableColumns.forEach((col) => {
      col.hasSearch = false;
      col.noSorting = true;
    });
    if (this.isShowMenus)
      this.tableColumns.push({
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: false,
        wrap: true,
      });
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl(''),
      contactsCount: new FormControl(''),
      type: new FormControl(''),
      smsCp: new FormControl(''),
      parentName: new FormControl(''),
    });
  }

  getEnumsValues() {
    this.getEnumValuesApi('PhonebookTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.PhonebookTypesEnumValues = values));
  }

  getComparisonObject(event: FieldSearcherOutput) {
    const fieldName = event.fieldName;
    delete event.fieldName;
    this.comparisonObjects =
      this.dynamicTableService.addOrRemoveComparisonObject(
        this.comparisonObjects,
        event,
        fieldName
      );
  }

  //api
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfPhonebookDto> {
    return this.currentService.phonebooksGetDescendantPhonebooksWithPagination({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        justCurrentOrganization: this.justCurrentOrganization,
      },
    });
  }

  onSubmit() {
    this.items = [];
    this.paginationModel.pageNumber = 1;
    this.getTableData();
  }
}
